// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@tailwind base;@tailwind components;@tailwind utilities", "",{"version":3,"sources":["/app/node_modules/tailwindcss/base.css"],"names":[],"mappings":"AAAA,cAAA,CAAA,oBAAA,CAAA,kBAAA","file":"application.scss","sourcesContent":["@tailwind base;\n"]}]);
// Exports
module.exports = exports;
